import React from 'react';
import { motion } from 'framer-motion';
// import heroImage from '../assets/new_heroImage.png';

import { Link } from 'react-router-dom';

// import { Playfair_Display } from 'next/font/google'

// const playfair = Playfair_Display({ subsets: ['latin'], weight: ['400', '700'] })


const Hero = () => {
  return (
    <section className="bg-white py-8">
      <div className="max-w-7xl mx-auto px-6 flex flex-col-reverse md:flex-row items-center justify-between">
        {/* Left Content */}
        <motion.div
          className="md:w-1/2 text-center md:text-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <h1 className="font-dmserif text-3xl md:text-5xl font-bold text-gray-900">
            Your Business Buddy<br />
            for Smarter Engagement<br />
            - WhatsApp & AI Chatbots
          </h1>
          <p className="text-gray-600 text-lg mb-6">
            Transform every conversation into a growth opporthunity with AI-powered messaging
          </p>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="mb-6 inline-block"
          >
            <Link
              to="/products"
              className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold shadow-lg hover:bg-blue-700 transition duration-300"
            >
              Try for free
            </Link>
          </motion.div>
          <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-4 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <span className="text-green-500 text-xl">✔</span> No setup fee
            </div>
            <div className="flex items-center gap-2">
              <span className="text-green-500 text-xl">✔</span> No credit card required
            </div>
          </div>
        </motion.div>

        {/* Right Image */}
        <motion.div
          className="md:w-1/2 flex items-center justify-center mt-10 md:mt-0 relative"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut', delay: 0.2 }}
        >
          <img
            src="/HeroImage.webp"
            // src = {heroImage}
            alt="WhatsApp Marketing Illustration"
            className="w-[300px] md:w-[400px] object-contain drop-shadow-xl"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
